import React, { createContext, useContext, useMemo} from 'react';

const MLLandingPageContext = createContext({
  updateWizardSubmission: () => {},
  additionalPolicyChangeProps: {
    isPolicyChangeAndTrasferToPayrollFlow: false
  }
});

export const useMLLandingPageContext = () => useContext(MLLandingPageContext);

export const MLLandingPageProvider = ({ children, updateWizardSubmission, additionalPolicyChangeProps}) => {
    
  const contextValue = useMemo(() => ({
    updateWizardSubmission,
    additionalPolicyChangeProps
    }), [updateWizardSubmission, additionalPolicyChangeProps]);
  
    return (
      <MLLandingPageContext.Provider value={contextValue}>
        {children}
      </MLLandingPageContext.Provider>
    );
  };